export function getCalendarEntriesPath(inkindRouteId: string) {
  return `inkinds/${inkindRouteId}/calendarEntries`;
}
